import { render, staticRenderFns } from "./BSReviewModal.vue?vue&type=template&id=d6bdbc08"
import script from "./BSReviewModal.vue?vue&type=script&lang=js"
export * from "./BSReviewModal.vue?vue&type=script&lang=js"
import style0 from "./BSReviewModal.vue?vue&type=style&index=0&id=d6bdbc08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports